export const LOADING = 'LOADING'




// WEBPACK FOOTER //
// ./src/vuex/modules/network/mutation-type.js